import React, { useEffect, useState } from 'react';
import ButtonBack from './images/x.png';
import LevelingPotion from './images/LevelingPotion.png';
import Info from './images/Icon_Info.png';
import useWeb3 from '../hooks/useSolanaWeb3';
import { toast } from 'react-hot-toast';
import useFetchNfts from '../hooks/useFetchNfts';

function ConfirmSelection({ onClose, stakeFee, antInfo, assignType, imageUri }) {

  const { handleLevelingGroundStake, handleTasksStake, fetchBlockchainData, fetchAllBalances, fetchTaskedNfts } = useWeb3()
  const { fetchNfts } = useFetchNfts()
  const [loading, setLoading] = useState(false);

  const handleLevelingGroundStakeButtonClicked = async () => {
    try {
      setLoading(true);
      await handleLevelingGroundStake(antInfo.mint, imageUri);
      await fetchAllBalances();
      await fetchNfts(3);
      toast.success("Assigned successfully!")
 
    }
    catch (err) {
      console.log("levleing ground assigne error:", err)
      if (err.data && String(err.data.message).includes("insufficient funds")) {
        return toast.error("Insufficient funds")
      }
      switch (true) {
        case String(err).includes("User rejected request"):
          toast.error("User rejected request")
          break;
        case String(err).includes("LevelingGround: you are not owner of this basic token"):
          toast.error("You are not owner of this token");
          break;
        case String(err).includes("LevelingGround: you are not owner of this premium token"):
          toast.error("You are not owner of this token");
          break;
        case String(err).includes("you don't have enough ant coin balance for stake fee"):
          toast.error("Insufficent $ANTC Stake Fee");
          break;
        case String(err).includes("your ant can't upgrade any more"):
          toast.error("can't upgrade anymore");
          break;
        default:
          toast.error("Something went wrong!")
          break;
      }
    } finally {
      setLoading(false)
      onClose()
    }

  }

  const handleTasksStakeButtonClicked = async () => {
    try {
      setLoading(true);
      await handleTasksStake(antInfo.mint, imageUri);
      await fetchBlockchainData();
      await fetchTaskedNfts();
      toast.success("Assigned successfully!")
    }
    catch (err) {
      console.log("tasks assigne error:", err)
      if (err.data && String(err.data.message).includes("insufficient funds")) {
        return toast.error("Insufficient funds")
      }
      switch (true) {
        case String(err).includes("User rejected request"):
          toast.error("User rejected request")
          break;
        case String(err).includes("Tasks: you are not owner of this basic token"):
          toast.error("You are not owner of this token");
          break;
        case String(err).includes("Tasks: you are not owner of this premium token"):
          toast.error("You are not owner of this token");
          break;
        case String(err).includes("Tasks: insufficient ant coin balance"):
          toast.error("Insufficent $ANTC Stake Fee");
          break;
        case String(err).includes("Tasks: premium ant level must be greater than minimum ant level requirement"):
          toast.error("ANT Level should be >= 5");
          break;
        case String(err).includes("Tasks: basic ant level must be greater than minimum ant level requirement"):
          toast.error("ANT Level should be >= 5");
          break;
        default:
          toast.error("Something went wrong!")
          break;
      }
    } finally {
      setLoading(false)
    }

  }

  const handleStakeButtonClicked = () => {
    if (assignType === "levelingGround") {
      console.log("leveling clicked")
      handleLevelingGroundStakeButtonClicked();
    }
    else if (assignType === "tasks") {
      console.log("tasks clicked")
      handleTasksStakeButtonClicked();
    }
  }
  
  return (
    <div className="popup-container">
      <div className="popup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} alt="Close button" />
        </button>
        <div className="popupinfo-holder" id="stake-amount">
          <h1>CONFIRM</h1>
          <div className="info-box">
            <p>Note your wallet will be charged {Number(stakeFee)} $ANTC Fee. Your ANT will be locked untill you redeem it.
            </p>
          </div>
          <button className="buy-button" id="right2" onClick={handleStakeButtonClicked} disabled={loading}>
            <span>{loading ? "Loading..." : "CONFIRM"}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmSelection;